/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { FIAT_DETAIL_DATA } from "./test-data/fiat.detail";
import { BUY_ASSET_IN_FIAT } from "../pages/ProductDetail/graphql/buy-asset-in-fiat.mutation";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { StorageModule } from "@vlinder-web/storage-module-react";

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

const SERVICE_NAME = "AssetService";
const log: any = LoggerModule.getInstance();
const storageService = StorageModule.getInstance();
const DEFAULT_APP_CONFIG = storageService.get("appConfig", "session");
export class ClaimDetailService {
    private static instance: ClaimDetailService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): ClaimDetailService {
        if (!ClaimDetailService.instance) {
            ClaimDetailService.instance = new ClaimDetailService(props);
        }
        return ClaimDetailService.instance;
    }

    async claimInital() {
        const _found = FIAT_DETAIL_DATA;
        return _found;
    }

    async getOrderId(orderId: string) {
        log.blue(`order Id inside services`, orderId);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: BUY_ASSET_IN_FIAT,
                    variables: {
                        storeId: DEFAULT_APP_CONFIG?.organization?.storeId,
                        tokenId: orderId
                    }
                });
                log.success(SERVICE_NAME, "get orderId result: ", res);
                // return res?.data?.getAssets;
                return {
                }
            }
        } catch (err) {
            log.error(SERVICE_NAME, "error in get assets", err);
            // throw Error(`${err?.message}`)
            return {
                pagination: {
                    nextOffset: 0,
                    totalItems: 0,
                },
                results: [],
            };
        }
        const _found = _.find(FIAT_DETAIL_DATA.asset.order_id, {
            idx: orderId,
        });
        return _found;
    }

    async fiatFinal(response: any) {
        return response;
    }
}
